module.exports = __webpack_public_path__ + "static/horizontal-logo-dark-bg-f89bcc06153d7d0d9dbdf4d92fdc80e5.png";